import React from 'react';

import Select from 'react-select';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);
const primaryColor = fullConfig.theme.colors.primary + 'B3';

function DownArrow() {
  return (
    <svg height="25" width="25" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const LiviuSelectTextStyle = {
  color: '#FCFCFC',
  fontFamily: 'Inter',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '150%',
};

const LiviuGlasslight = {
  boxShadow: '0 4px 30px 0 rgba( 0, 0, 0, 0.05 )',
  backdropFilter: 'blur(14px)',
  webkitBackdropFilter: 'blur( 14px )',
  borderRadius: '8px',
  border: '1px solid rgba( 255, 255, 255, 0.08 )',
  borderTop: '1px solid rgba( 255, 255, 255, 0.16 )',
  borderLeft: '1px solid rgba( 255, 255, 255, 0.16 )',
};

const getStyles = (align = 'left', width = 120) => {
  return {
    container: (baseStyles, _state) => ({
      ...baseStyles,
      width: `${width}px`,
      textAlign: align,
      ...LiviuSelectTextStyle,
    }),
    valueContainer: (baseStyles, _state) => ({
      ...baseStyles,
      color: '#FCFCFC',
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '0px',
      paddingBottom: '0px',
    }),
    singleValue: (baseStyles, _state) => ({
      ...baseStyles,
      ...LiviuSelectTextStyle,
      margin: '0px',
    }),
    input: (baseStyles, _state) => ({
      ...baseStyles,
      ...LiviuSelectTextStyle,
    }),
    control: (baseStyles, _state) => ({
      ...baseStyles,
      background: primaryColor,
      paddingTop: '4px',
      paddingBottom: '4px',
      minHeight: 'none',
      ...LiviuGlasslight,
    }),
    menu: (baseStyles, _state) => ({
      ...baseStyles,
      textAlign: align,
      width: `${width}px`,
      marginTop: '-7px',
      paddingTop: '0px',
      ...LiviuGlasslight,
      background: primaryColor,
      ...LiviuSelectTextStyle,
      borderTop: '0px',
      borderRadius: '0px 0px 8px 8px',
    }),
    menuList: (baseStyles, _state) => ({
      ...baseStyles,
      paddingRight: '24px',
      color: '#FCFCFC',
      borderRadius: '0px 0px 8px 8px',
    }),
    group: (baseStyles, _state) => ({
      ...baseStyles,
      color: '#FCFCFC',
    }),
    groupHeading: (baseStyles, _state) => ({
      ...baseStyles,
      color: '#FCFCFC',
    }),
    option: (baseStyles, _state) => ({
      ...baseStyles,
      background: 'transparent',
      color: '#FCFCFC',
      borderRadius: '0px 0px 8px 8px',
    }),
  };
};

const SelectField = ({
  defaultValue,
  options,
  onChange = () => null,
  width = 170,
  align = 'center',
}) => {
  const styles = getStyles(align, width);
  return (
    <Select
      styles={styles}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator: () => DownArrow(),
      }}
      isSearchable={false}
      defaultValue={defaultValue}
      options={options}
      onChange={onChange}
    />
  );
};

export { SelectField };
